import Vue from "vue";
import Vuex from "vuex";
import home from "./home";
import recruit from "./recruit";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    home,
    recruit
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js